import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export class PageTitleBottomBar {
	constructor() {
		this.bottomBar = document.querySelector(".page-title-bottom-bar");
		this.bottomBarTitle = document.querySelector(
			".page-title-bottom-bar__title"
		);
		this.footer = document.querySelector(".next-link, .footer");
		this.pageHeadline = document.querySelector(
			".intro__headline, h1, .hero__headline"
		);
		this.isReducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)"
		).matches;

		if (!this.bottomBar || !this.footer) return;

		this.init();
	}

	init() {
		// Get computed header height from scroll-padding-block-start
		const computedStyle = getComputedStyle(document.documentElement);
		const headerHeight = computedStyle
			.getPropertyValue("scroll-padding-block-start")
			.trim();

		// Hide title initially
		if (this.bottomBarTitle) {
			gsap.set(this.bottomBarTitle, {
				autoAlpha: 0,
				yPercent: this.isReducedMotion ? 0 : 100,
			});
		}

		// Show title when page headline scrolls out of view (accounting for fixed header)
		if (this.pageHeadline && this.bottomBarTitle) {
			gsap.to(this.bottomBarTitle, {
				autoAlpha: 1,
				yPercent: 0,
				ease: "power2.inOut",
				duration: 0.25,
				scrollTrigger: {
					trigger: this.pageHeadline,
					start: `bottom top+=${headerHeight}`,
					end: `bottom top+=${headerHeight}-=50`,
					toggleActions: "play none none reverse",
				},
			});
		}

		// Hide entire bar when approaching next link
		gsap.to(this.bottomBar, {
			autoAlpha: 0,
			yPercent: this.isReducedMotion ? 0 : 100,
			ease: "power2.inOut",
			duration: 0.25,
			scrollTrigger: {
				trigger: this.footer,
				start: "top bottom",
				end: "top bottom+=100",
				toggleActions: "none play none reverse",
			},
		});
	}
}
